import React, { useState } from 'react';
import { Lobby } from './components/Lobby/Lobby';
import { Game } from './components/Game/Game';
import { Results } from './components/Dashboard/Results';
export function App() {
  const [gameState, setGameState] = useState({
    screen: 'lobby',
    team: [],
    currentPhase: 0,
    phases: [{
      id: 1,
      name: 'Team Formation',
      type: 'discussion',
      completed: false
    }, {
      id: 2,
      name: 'Idea Generation',
      type: 'cards',
      completed: false
    }, {
      id: 3,
      name: 'Problem Validation',
      type: 'challenge',
      completed: false
    }, {
      id: 4,
      name: 'Solution Design',
      type: 'discussion',
      completed: false
    }, {
      id: 5,
      name: 'Business Model',
      type: 'cards',
      completed: false
    }, {
      id: 6,
      name: 'Pitch Development',
      type: 'challenge',
      completed: false
    }],
    phaseSummaries: {},
    startupDetails: {
      name: '',
      description: '',
      logo: '',
      journey: '',
      resources: [],
      mentors: [],
      deliverables: [],
      timeline: []
    }
  });
  const startGame = team => {
    setGameState(prev => ({
      ...prev,
      screen: 'game',
      team
    }));
  };
  const completePhase = (phaseId, summary) => {
    setGameState(prev => {
      const updatedPhases = prev.phases.map(phase => phase.id === phaseId ? {
        ...phase,
        completed: true
      } : phase);
      const nextPhase = updatedPhases.findIndex(phase => !phase.completed);
      const updatedSummaries = {
        ...prev.phaseSummaries,
        [phaseId]: summary
      };
      // If all phases are complete, move to results
      const newScreen = nextPhase === -1 ? 'results' : 'game';
      return {
        ...prev,
        phases: updatedPhases,
        currentPhase: nextPhase === -1 ? prev.currentPhase : nextPhase,
        phaseSummaries: updatedSummaries,
        screen: newScreen
      };
    });
  };
  const saveResults = results => {
    setGameState(prev => ({
      ...prev,
      startupDetails: {
        ...prev.startupDetails,
        ...results
      }
    }));
  };
  const resetGame = () => {
    setGameState({
      screen: 'lobby',
      team: [],
      currentPhase: 0,
      phases: gameState.phases.map(phase => ({
        ...phase,
        completed: false
      })),
      phaseSummaries: {},
      startupDetails: {
        name: '',
        description: '',
        logo: '',
        journey: '',
        resources: [],
        mentors: [],
        deliverables: [],
        timeline: []
      }
    });
  };
  return <div className="w-full min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 text-gray-800" data-id="element-0">
      {gameState.screen === 'lobby' && <Lobby onStartGame={startGame} data-id="element-1" />}
      {gameState.screen === 'game' && <Game phases={gameState.phases} currentPhase={gameState.currentPhase} team={gameState.team} onCompletePhase={completePhase} data-id="element-2" />}
      {gameState.screen === 'results' && <Results team={gameState.team} phaseSummaries={gameState.phaseSummaries} startupDetails={gameState.startupDetails} onSaveResults={saveResults} onRestart={resetGame} data-id="element-3" />}
    </div>;
}